<template>
  <div class="grid-responsive">
    <div class="grid">
      <template 
        v-for="(article, index) in articles"
      >
        <div 
          v-if="article.isCategory"
          class="grid-item"
          :style="{ 
            backgroundColor: $store.getters.printCategoryColor(article),
            color: chipTextColor($store.getters.printCategoryColor(article))
          }"
          @click.self="pickChildCategory(article.id)"
        >
          <icon 
            name="folder-open-solid" 
            style="color: yellow; height: 20px; width: 20px; margin-right: 10px;"
          />
          {{ article.name }}
        </div>
        <div 
          v-else
          class="grid-item"
          :style="{ 
            backgroundColor: $store.getters.printArticleColor(article),
            color: chipTextColor($store.getters.printArticleColor(article))
          }"
          @click.self="pickArticle(article)"
        >
          {{ article.name }}
          <span
            v-if="article.outOfStock"
            @click.prevent="alertOutOfStock(article.outOfStock)"
            class="out-of-stock" >
            !!!
          </span>
        </div>
      </template>
    </div>
    <mixer-side v-click-outside="closeOnClickOutside" v-show="$store.state.toggle.isMixerModalVisible"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  RESET_ALL_TOGGLE,
  TOGGLE_MIXER_MODAL,
  SET_MESSAGE_MODAL,
} from '@/store/mutation-types';
import MixerSide from '@/components/MixerSide.vue';

export default {
  name: 'grid',
  components: {
    MixerSide,
  },
  destroyed() {
    this.$store.commit(RESET_ALL_TOGGLE);
  },
  computed: {
    articles() {
      return this.getScreenArticles();
    },
    ...mapGetters(
      [
        'getScreenArticles',
        'getArticleProperty',
        'getCloneArticleList',
        'getArticleCommission',
        'getLastNormalItem',
        'getArticleClone'
      ],
    ),
  },
  methods: {
    closeOnClickOutside(event) {
      if (event.target.id !== 'toggleMixerModalTrigger'
          && event.target.className
          && typeof(event.target.className) == 'string'
          && event.target.className.indexOf('calculator-key') === -1
      ) {
        this.$store.commit(TOGGLE_MIXER_MODAL, false);
      }
    },
    isLastNormalItemNotCreditBack() {
      return this.getLastNormalItem && this.getLastNormalItem.qty > 0;
    },
    pickArticle(article) {
      if (!this.$store.state.toggle.isCreditBackButtonActive) {
        const result = this.$store.getters.pickArticle(article);
        let articleClone = this.getArticleClone(article) ? this.getArticleClone(article) : article;
        if (!result) {
          this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Please create new order or get bill'));
        } else if (this.isLastNormalItemNotCreditBack() && this.getArticleCommission(article.id) && articleClone.commissionActive) {
          this.$router.push({
            name: 'set-commission',
            params: {
              product: this.getLastNormalItem ? this.getLastNormalItem.product : null,
              force: true,
            },
          });
        }
      }
    },
    alertOutOfStock(ingredientIdList) {
      const ingredients = ingredientIdList.map(id => {
        return this.$store.state.article.stockItems[id].name;
      });
      this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Out of stock') + ': ' + ingredients.join(', '));
    },
    stockAlert(article) {
      return this.isOutOfStock(
        article,
        this.getCloneArticleList,
        this.getCloneStockItemList,
        this.getRecipeMap,
        this.getStockMap,
      );
    },
    hexToRgb(hex) {
      const result = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
      ] : null;
    },
    chipTextColor(backgroundHex) {
      const rgb = this.hexToRgb(backgroundHex);
      if(!rgb) return 'black';
      const brightness = Math.round(((parseInt(rgb[0]) * 299) +
                      (parseInt(rgb[1]) * 587) +
                      (parseInt(rgb[2]) * 114)) / 1000);
      return (brightness > 125) ? 'black' : 'white'; 
    },
    pickChildCategory(id) {
      this.$store.state.article.currentScreen = {
        id,
        type: 'category',
      };
    }
  },
  /* eslint-disable */
  directives: {
    'click-outside': {
      bind(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }
        }
        // Define Handler and cache it on the element
        const { bubble } = binding.modifiers;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind(el) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  /* eslint-enable */
};
</script>
